import { useMutation, useQueries, useQuery } from '@tanstack/react-query';
import { fetchReportData, fetchSpeceficRangeReport } from '../services/report-service';
import { usePatientsContext } from 'store/context/patient-context';
import { queryKeys } from 'react-query/constant';
import { HypoInfoApi } from '../services/hypo-service';

const useReport = (patientId, selectedRange) => {
  return useQuery(
    [queryKeys.reportData, patientId],
    () => fetchReportData(patientId),
    {
      
      onError: (error) => console.log(error),
      enabled: typeof selectedRange === 'number',
      refetchOnWindowFocus: false,
    }
  );
};

export const useReview = (patientId, chosen) => {
  return useQueries({
    queries: [
      {
        queryKey: [queryKeys.reportData, patientId],
        queryFn: () => fetchReportData(patientId),
        enabled: typeof chosen === 'number',
            refetchOnWindowFocus: false,
      },
      {
        queryKey: [queryKeys.hypoInfo, patientId, chosen],
        queryFn: () => HypoInfoApi(patientId, chosen),
        enabled: typeof chosen === 'number',
      }
    ]
  });
};

const useCustomDateReport = (date) => {
  const { handleOpenSnackbar } = usePatientsContext();
  return useMutation({
    mutationFn: fetchSpeceficRangeReport,
    enabled: date.from && date.to,
    onError: (error) => {
      handleOpenSnackbar(error.response.data.messages, 'error');
    }
  });
};

const useGet365DayReportData = (patientId, chosen) => {
  return useQuery(
    [queryKeys.reportData, patientId, chosen],
    () => fetchReportData(patientId, chosen),
    {
      enabled: +chosen === 365,
      refetchOnWindowFocus: false,
      onError: (error) => console.log(error)
    }
  );
};

export { useReport, useGet365DayReportData, useCustomDateReport };
